import Cookies from 'js-cookie';
import { injectGTMCode } from './boot-inject-gtm-code.js';
import {
    CLOUDFLARE_COOKIE_FIELDS,
    getClientCloudflareInfo,
    getClientIpSource,
} from './utils-get-user-info';

export function initGTM() {
    window.dataLayer = window.dataLayer || [];

    // Setting the `AcronisInternal` cookie for store.acronis.com
    const userType = getClientIpSource();
    const isInternal = userType === 'internal';
    Cookies.set('AcronisInternal', isInternal.toString(), {
        path: '/',
        domain: '.acronis.com',
        expires: 30, // days
    });

    const cloudflareInfo = getClientCloudflareInfo();
    CLOUDFLARE_COOKIE_FIELDS.forEach(({ name }) => {
        const value = cloudflareInfo[name];
        if (value) {
            Cookies.set(name, value, { path: '/' });
        } else {
            Cookies.remove(name, { path: '/' });
        }
    });

    const referrer = Cookies.get('_vwo_referrer');
    if (referrer) {
        Cookies.remove('_vwo_referrer', { path: '/', domain: '.acronis.com' });
    }

    window.dataLayer.push({
        NewWebsite: 1,
        userType,
        ...(referrer && { vwo_referrer: referrer }),
    });

    /* eslint-disable no-underscore-dangle */
    if (!window._gtm_init) {
        window._gtm_init = 1;
        injectGTMCode();
    }
    /* eslint-enable no-underscore-dangle */
}
